import type { Desenlace } from '@/lib/cuadro/agregaciones';

// Desenlace del periodo (prototipo: donut + dlegend + total central). Arcos
// por stroke-dasharray sobre círculo; los segmentos a 0 se omiten.

const COLOR: Record<string, string> = {
  resueltas: 'var(--status-ok)',
  esc_operaciones: 'var(--status-esc)',
  esc_comercial: 'var(--status-night)',
  esc_otras: 'var(--text-mute)',
  sin_analizar: 'var(--status-live)',
};

const R = 54;
const CIRC = 2 * Math.PI * R;

export function GraficaDonut({ desenlace }: { desenlace: Desenlace }) {
  const visibles = desenlace.segmentos.filter((s) => s.valor > 0);
  let acumulado = 0;

  return (
    <div className="flex items-center gap-5">
      <svg
        viewBox="0 0 140 140"
        className="block h-[132px] w-[132px] shrink-0"
        role="img"
        aria-label={`Desenlace de ${desenlace.total} llamadas del periodo`}
      >
        <circle cx="70" cy="70" r={R} fill="none" stroke="var(--surface-3)" strokeWidth="16" />
        {visibles.map((s) => {
          const frac = desenlace.total > 0 ? s.valor / desenlace.total : 0;
          const offset = acumulado;
          acumulado += frac;
          return (
            <circle
              key={s.clave}
              cx="70"
              cy="70"
              r={R}
              fill="none"
              stroke={COLOR[s.clave]}
              strokeWidth="16"
              strokeDasharray={`${frac * CIRC} ${CIRC}`}
              strokeDashoffset={-offset * CIRC}
              transform="rotate(-90 70 70)"
            />
          );
        })}
        <text
          x="70"
          y="66"
          textAnchor="middle"
          fontSize="24"
          fontWeight="600"
          fill="var(--navy)"
          className="mono"
        >
          {desenlace.total}
        </text>
        <text x="70" y="84" textAnchor="middle" fontSize="10" fill="var(--text-dim)">
          llamadas
        </text>
      </svg>

      <ul className="m-0 flex-1 list-none space-y-1.5 p-0">
        {desenlace.segmentos.map((s) => (
          <li key={s.clave} className="flex items-center gap-2 text-[12px] text-[var(--text-2)]">
            <span
              className="h-2.5 w-2.5 shrink-0 rounded-[3px]"
              style={{ background: COLOR[s.clave] }}
            />
            <span className="min-w-0 flex-1 truncate">{s.etiqueta}</span>
            <span className="mono text-[var(--navy)] font-semibold">{s.valor}</span>
            <span className="mono w-9 text-right text-[var(--text-dim)]">{s.pct}%</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
